import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import { Button } from '../../../ui/Button';
import { MessageIcon, PhoneIcon } from '../../../ui/icons';
import { useContactFormAction } from '../ContactForm/useContactFormAction';
import { footerActions } from './propertyManagerModule.styles';

export const PropertyManagerFooter = () => {
  const { openContactForm, contactFormOverlay } = useContactFormAction();
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);
  const contactPhone = listing?.listedBy?.contactPhone;

  if (!listing || listing.active === false) return null;

  const handleCall = () => {
    if (contactPhone) {
      window.location.href = `tel:${contactPhone}`;
    }
  };

  return (
    <div className={footerActions}>
      <Button
        shape="rectangle"
        tone="brand"
        emphasis="filled"
        fluid={true}
        icon={<MessageIcon />}
        onClick={openContactForm}
      >
        Message
      </Button>
      {contactPhone && (
        <Button
          shape="rectangle"
          tone="brand"
          emphasis="outlined"
          fluid={true}
          icon={<PhoneIcon />}
          onClick={handleCall}
        >
          Call
        </Button>
      )}
      {contactFormOverlay}
    </div>
  );
};
